import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { usePostHog } from '#Root/usePostHog';

export function usePageViewTracking() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (window.gtag && window.dataLayer) {
      window.gtag('set', 'page_path', location.pathname + location.search);
      window.gtag('event', 'page_view');
    }

    posthog.capture('$pageview', {
      $current_url: window.location.href,
    });

    window._hsq = window._hsq || [];
    window._hsq.push(['setPath', location.pathname + location.search]);
    window._hsq.push(['trackPageView']);
  }, [location, posthog]);
}
